<div class="table-wrapper" (scroll)="sessionListDataSource.onScroll($event)">
	<table
	*ngIf="sessionListDataSource"
	mat-table
	[dataSource]="sessionListDataSource"
	fixedLayout="true"
	class="main-table"
	#tableContainer
>
	<!-- Affordance Column -->
	<ng-container matColumnDef="affordance">
		<th mat-header-cell *matHeaderCellDef></th>
		<td mat-cell *matCellDef="let session">
			<dot-indicator
				[session]="session"
				[color]="(session.isLive()) ? 'red' : 'green'">
			</dot-indicator>
		</td>
	</ng-container>

	<!-- Name Column -->
	<ng-container matColumnDef="name">
		<th mat-header-cell *matHeaderCellDef>
			<span translate="common_name"></span>
		</th>
		<td mat-cell *matCellDef="let session" [matTooltip]="session.description">
			<span class="flex">
				<ng-container *ngIf="session.isRecorded()">
					<div *ngIf="!ngxSessionService.getMedia(session); else hasMediaImg" class="media-thumbnail pending-thumbnail">
						<span *ngIf="selectedService.getActivity().isConversationBoard(); else notConversationBoard">
							<img class="logo not-loading"
								alt="GoReact Logo"
								src="https://staticassets.goreact.com/logo-goreact-spot-2022.svg"/>
						</span>
						<ng-template #notConversationBoard>
							<loading [width]="'18px'" [height]="'18px'"></loading>
						</ng-template>
					</div>

					<ng-template #hasMediaImg>
						<thumbnail *ngIf="ngxSessionService.getMedia(session).isReady()"
							data-cy="media-ready"
							[src]="ngxSessionService.getMedia(session).thumbnail_url"
							[duration]="ngxSessionService.getMedia(session).duration"
							[isPractice]="session.isPractice() && selectedService.getActivity().allowsPractice()"
							[fallbackIcon]="'ficon-app-camcorder'"
							class="media-thumbnail recorded-thumbnail {{FirstCommentTourClasses.sessionTablePulse}}"
						>
						</thumbnail>

						<div *ngIf="ngxSessionService.getMedia(session).isPending()" class="media-thumbnail pending-thumbnail" data-cy="session-pending">
							<loading [width]="'18px'" [height]="'18px'"></loading>
						</div>

						<div *ngIf="ngxSessionService.getMedia(session).isFailed()" class="media-thumbnail failed-thumbnail">
							<i class="ficon-app-warning-circle-outline"></i>
						</div>
					</ng-template>
				</ng-container>

				<ng-container *ngIf="!session.isRecorded()">
					<div *ngIf="ngxSessionService.shouldDisplayJoinButton(session)" class="media-thumbnail live-thumbnail">
						<span>{{'session-join' | translate}}</span>
					</div>
				</ng-container>
				<span class="description" data-cy="session-description">{{ session.description }}</span>
				<span *ngIf="!session.description?.length">&#8212;</span>
			</span>
		</td>
	</ng-container>

	<!-- Participants Column -->
	<ng-container matColumnDef="participants">
		<th mat-header-cell *matHeaderCellDef>
			<span translate="participants"></span>
		</th>
		<td mat-cell *matCellDef="let session" [matTooltip]="session.getFormattedPresenters()" tabindex="0">
			<ellipsis-with-count [nameList]="session.getPresenterNames()"></ellipsis-with-count>
			<span *ngIf="!session.getPresenterNames().length">
				<span
					*ngIf="selectedService.getActivity().isConversationBoard(); else notConversationBoard"
					class="group-discussion"
					translate="filter-presenter-names_group">
				</span>
				<ng-template #notConversationBoard>
					—
				</ng-template>
			</span>
		</td>
	</ng-container>

	<!-- Comments Column -->
	<ng-container matColumnDef="comments">
		<th mat-header-cell *matHeaderCellDef>
			<span translate="comments"></span>
		</th>
		<td mat-cell *matCellDef="let session">
			<span *ngIf="session.num_comments" class="comment">
				<span><i class="ficon-app-comment-outline"></i></span>
				<span>{{session.num_comments}}</span>
			</span>
			<span *ngIf="!session.num_comments" class="comment">—</span>
		</td>
	</ng-container>

	<!-- Score Column -->
	<ng-container matColumnDef="score" *ngIf="shouldDisplayScoreColumn() && {
		isScoreEnabled: this.selectedService.getActivity().isScoreEnabled(),
		totalPoints: this.selectedService.getActivity().getTotalPoints()
		} as data">
		<th mat-header-cell *matHeaderCellDef [hidden]="!data.isScoreEnabled">
			<span translate="common_score"></span>
		</th>
		<td mat-cell *matCellDef="let session" [hidden]="!data.isScoreEnabled">
			<ng-container *ngIf="ngxSessionService.shouldDisplayScore(session)">
				<span *ngIf="session.isScoreAssigned()" class="score">{{session.score}} / {{data.totalPoints}}</span>
				<span *ngIf="!session.isScoreAssigned()" class="unscored" translate="common_unscored"></span>
			</ng-container>
		</td>
	</ng-container>

	<!-- Status Column -->
	<ng-container matColumnDef="status">
		<th mat-header-cell *matHeaderCellDef>
			<span translate="common_date"></span>
		</th>
		<td mat-cell *matCellDef="let session">

			<!-- Recorded information -->
			<div *ngIf="session.isRecorded()">
				<span *ngIf="!ngxSessionService.getMedia(session); else hasMediaStatus" class="pending-text italic">
					<span *ngIf="selectedService.getActivity().isConversationBoard(); else noRecording">—</span>
					<ng-template #noRecording>
						<span translate="single-attempt-activity_no-recording" data-cy="allow-retake-link"></span>
					</ng-template>
				</span>

				<ng-template #hasMediaStatus>
					<ng-container *ngIf="ngxSessionService.getMedia(session).isReady()">
						<span *ngIf="session.isPosted()" class="date-posted">
							{{ "session-card_date-posted" | translate: {"date": session.posted_at | date, "time": session.posted_at | date:'shortTime'} }}
						</span>

						<span *ngIf="!session.isPosted()"
							class="post-processing-text red-text"
							translate="common_post-recording">
						</span>
					</ng-container>
					<span
						*ngIf="ngxSessionService.getMedia(session).isPending()"
						tabindex="0"
						class="pending-text italic"
						[matTooltip]="'session-card_processing' | translate"
						translate="common_processing_processing"
						data-cy="processing-text">
					</span>
					<span *ngIf="ngxSessionService.getMedia(session).isFailed()" class="failed-text red-text" translate="common_processing_failed"></span>
				</ng-template>
			</div>

			<!-- Live information -->
			<div *ngIf="!session.isRecorded()">
				<span *ngIf="session.isAwaitingStart()" class="awaiting-text italic" translate="common_processing_awaiting-start"></span>
				<span *ngIf="session.isLive()" class="is-live-text red-text" translate="common_processing_in-progress"></span>
			</div>
		</td>
	</ng-container>

	<!-- Actions Column -->
	<ng-container matColumnDef="actions">
		<th mat-header-cell *matHeaderCellDef></th>
		<td mat-cell *matCellDef="let session" (click)="$event.stopPropagation();" (keyup.enter)="$event.stopPropagation()">
			<span class="actions">
				<button *ngIf="ngxSessionService.hasVideoSharePermission(session) && session.isPosted()"
					mat-icon-button
					class="manage-video-share-btn"
					data-cy="share-button"
					[matTooltip]="'common_share' | translate "
					(click)="shareSession(session)">
					<i class="ficon-app-share"></i>
				</button>
				<button *ngIf="ngxSessionService.shouldDisplayOptionsMenu(session)"
					class="dropdown-menu-btn"
					data-cy="session-dropdown-menu"
					mat-icon-button
					[attr.aria-label]="'session-list-item_view-options' | translate "
					(click)="openMenu($event, session)">
					<i class="ficon-app-dots-vertical"></i>
				</button>
			</span>
		</td>
	</ng-container>

	<tr
		mat-header-row
		*matHeaderRowDef="displayColumns"
	></tr>
	<tr
		class="{{FirstCommentTourClasses.sessionTableComplete}}"
		mat-row
		tabindex="0"
		[ngClass]="{ 'viewed': !unviewedState(session) }"
		[attr.aria-label]="session.description"
		*matRowDef="let row; columns: displayColumns; let session"
		(contextmenu)="openMenu($event, session)"
		(keyup.enter)="goToSession.emit(session)"
		data-cy="session-row-or-card"
		(click)="goToSession.emit(session)"></tr>
</table>

<menu>
	<session-menu
		[session]="selectedSession"
		>
	</session-menu>
</menu>

</div>
